export default __webpack_public_path__ + "static/media/Gaming.431d0534.png";